import {IVideo} from 'app/components/tv/models/video';
import StaigeVideo from 'app/components/tv/models/staigeVideo';
import SportvideoVideo from 'app/components/tv/models/sportvideoVideo';
import SporttotalVideo from 'app/components/tv/models/sporttotalVideo';
import ViprtecVideo from 'app/components/tv/models/viprtecVideo';
import YousportVideo from 'app/components/tv/models/YousportVideo';

enum VideoSource {
  StaigeTV = 'staige',
  SportVideo = 'sportvideo',
  Viprtec = 'viprtec',
  SportTotal = 'sporttotal',
  Yousport = 'yousports',
}

export default class VideoCreator {
  static createVideo(video: IVideo): IVideo {
    if (video.category === VideoSource.StaigeTV) {
      return new StaigeVideo(video);
    } else if (video.category === VideoSource.SportVideo) {
      return new SportvideoVideo(video);
    } else if (video.category === VideoSource.Viprtec) {
      return new ViprtecVideo(video);
    } else if (video.category === VideoSource.SportTotal) {
      return new SporttotalVideo(video);
    } else if (video.category === VideoSource.Yousport) {
      return new YousportVideo(video);
    } else {
      throw new Error(`Unknown video category: ${video.category}`);
    }
  }
}
